import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { PRODUCTS } from '@/data/products';
import { motion } from 'framer-motion';

export const ProductGrid = ({ compact = false }) => {
  return (
    <section id="products" className="relative py-24 md:py-32 bg-parchment/40">
      <div className="container mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="font-script text-2xl text-leaf">the product line</div>
            <h2 className="font-display text-4xl sm:text-5xl text-primary font-medium leading-tight mt-1">
              Eight plant-based lines,<br/>
              <span className="italic font-light">one trusted bakery.</span>
            </h2>
          </div>
          <Link to="/products" className="inline-flex items-center gap-2 text-primary font-medium hover:text-leaf transition-colors">
            Browse all 8 sell sheets <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.55, delay: (i % 4) * 0.05 }}
              className="flex flex-col"
            >
              <Link
                to={`/products/${p.slug}`}
                className="group relative flex flex-col h-full rounded-3xl bg-card border border-border/70 overflow-hidden shadow-soft hover:shadow-pop hover:-translate-y-1.5 transition-all duration-500"
              >
                <div className="relative aspect-[5/6] overflow-hidden bg-secondary">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-[1.6s]"
                  />
                  <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background/85 backdrop-blur text-[10px] uppercase tracking-[0.16em] text-primary font-medium">
                    0{i + 1} · {p.category}
                  </div>
                  <div className="absolute top-3 right-3 h-9 w-9 rounded-full bg-background/85 backdrop-blur grid place-items-center text-primary group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
                    <ArrowUpRight className="h-4 w-4" />
                  </div>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="font-display text-xl font-semibold text-primary leading-tight">{p.name}</h3>
                  <p className="text-sm text-muted-foreground mt-1.5 line-clamp-2">{p.tagline}</p>
                  <div className="mt-auto pt-4 flex items-center justify-between text-xs text-muted-foreground">
                    <span className="uppercase tracking-[0.16em]">{p.unitCase}</span>
                    <span className="font-medium text-leaf">{p.variants.length} SKUs</span>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
